import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { PiUploadSimpleLight } from "react-icons/pi";
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import UploadContent from './UploadModal';

const workflow = [
    {
        title: 'Login or Sign Up',
        description:
            'Create an account or log in to your dashboard to get started. All your projects and uploads stay securely organized in one place.'
    },
    {
        title: 'Choose Video Type & Plan',
        description:
            'Select the kind of video you want—Reel, Vlog, Promo, etc.—and pick a pricing plan that fits your needs. No hidden charges, just flexibility.'
    },
    {
        title: 'Upload Your Videos',
        description:
            'Easily drag and drop your raw footage. We support all common formats and large file uploads so you can focus on capturing the content.'
    },
    {
        title: 'Add Instructions for Editors',
        description:
            'Tell us what you want: your style, tone, music preferences, and any must-have edits. The more details, the better your final cut.'
    },
    {
        title: 'Relax While We Edit',
        description:
            'Once your project is submitted, our expert editors get to work. You’ll receive the first cut quickly—with unlimited revisions until perfect.'
    }
];


function Upload({ planBuyed }) {
    const [showModal, setShowModal] = useState(false); 
    const handleShow = () => setShowModal(true); 
    const handleClose = () => setShowModal(false); 
    const { authenticated } = useAuth();
    const navigate = useNavigate(); 

    const scrollToPlan = () => {
        const section = document.getElementById('plans-section');
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    };


    return (
        <>
            <section id="upload-section" className="upload">
                <Container>
                    <Row className="d-flex align-items-stretch justify-content-between flex-wrap">
                        {/* Right side - text content */}
                        <Col xs={12} md={12} lg={6}>
                            <div className="h-100 d-flex flex-column justify-content-center">
                                <h2>How It Works</h2>
                                {workflow.map((item, index) => (
                                    <div key={index} className="item">
                                        <div className="step-number me-3">
                                            <div className='step-number-inner'>
                                                {index + 1}
                                            </div>
                                        </div>
                                        <div className="content-item">
                                            <strong>{item.title}</strong>
                                            <p className="mb-0">{item.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Col>
                        {/* Left side - placeholder for image or content */}
                        <Col xs={12} md={12} lg={6} className='upload-card-wraper'>
                            <div className="upload-card text-center w-100 d-flex flex-column justify-content-center">
                                {authenticated && (
                                    <>
                                        {planBuyed && (
                                            <div className="upload-icon-wrapper mx-auto">
                                                <button className="upload-icon-btn" onClick={handleShow}>
                                                    <PiUploadSimpleLight />
                                                </button>
                                            </div>
                                        )}
                                        {!planBuyed && (
                                            <div className="upload-icon-wrapper mx-auto">
                                                <button className="upload-icon-btn" onClick={scrollToPlan}>
                                                    <PiUploadSimpleLight />
                                                </button>
                                            </div>
                                        )}
                                    </>
                                )}
                                {!authenticated && (
                                    <div className="upload-icon-wrapper mx-auto">
                                        <button
                                            className="upload-icon-btn"
                                            onClick={() => {
                                                if (authenticated) {
                                                    handleShow(); // Show upload modal
                                                } else {
                                                    navigate('/signin'); // Redirect to login
                                                }
                                            }}
                                        >
                                            <PiUploadSimpleLight />
                                        </button>
                                    </div>
                                )}
                                <h5 className="fw-bold text-white">Upload your raw footage</h5>
                                <p className="text-white mb-1">We accept MP4, MOV, AVI, WMV, MKV, and more</p>
                                <p className="text-white mb-1">
                                    For any uncertainties, feel free to reach out to our{' '}
                                    <a href="/support" className="text-white text-decoration-underline">
                                        Support team
                                    </a>.
                                </p>
                                {!authenticated && (
                                    <small>
                                        <strong>Please login & Buy a Plan</strong> before uploading your videos.
                                    </small>
                                )}
                                {authenticated && !planBuyed && (
                                    <small>
                                        <strong>Please Buy a Plan</strong> before uploading your videos.
                                    </small>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Pass the setShowModal and showModal to the UploadContent component */}
            <UploadContent showModal={showModal} setShowModal={setShowModal} />
        </>
    );
}

export default Upload;
